import React, { useContext, useState } from 'react';
import { useTeamLogos } from '../hooks/team';
import { getProxyUrl } from '../utils/image';
import { useCalendar } from '../hooks/calendar';
import { UserContext } from '../context/user-context';
import { RequireLoginModal } from './RequireLoginModal';
import { Modal } from './Modal';

export default function TeamCalendar({ teams }) {
  const [teamLogos] = useTeamLogos();
  const { getTeamCalendarUrl } = useCalendar();
  const { isUserLoggedIn, login } = useContext(UserContext);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showCalendarModal, setShowCalendarModal] = useState(false);

  const getTeamLogo = (abbrv) => {
    const team = teamLogos.find((x) => x.abbrv === abbrv);

    const url = getProxyUrl(team?.logo || team?.logoImageUrl, 100, 100);
    return url;
  };

  const getArenaName = (abbrv) => {
    const team = teamLogos.find((x) => x.abbrv === abbrv);

    return team?.arena?.name || '';
  };

  const onAddToCalendar = async (abbrv) => {
    if (isUserLoggedIn()) {
      setShowCalendarModal(getTeamCalendarUrl(abbrv));
    } else {
      setShowLoginModal(true);
    }
  };

  if (teamLogos && teams) {
    return (
      <>
        {!isUserLoggedIn() && (
          <p className="text-color-primary-white mb-4">
            För att prenumerera på en kalender behöver du logga in med ditt
            Fotbollskonto. Saknar du ett Fotbollskonto?{' '}
            <a className="text-color-primary-yellow" href="/auth/login">
              Registrera dig gratis här!
            </a>
          </p>
        )}
        {teams.map((t) => (
          <div key={t.abbrv} className="col-12 col-md-4 col-lg-3 mb-4">
            <div className="data-container data-container--gradient p-4 d-flex flex-column justify-content-center align-items-center">
              <img
                style={{ maxHeight: 100 }}
                className="team-ticket-logo mb-4"
                src={getTeamLogo(t.abbrv)}
                alt={t.abbrv}
              />
              <p className="heading-stats-name heading-stats-name--medium mt-0 mb-2 text-center">
                {t.name}
              </p>
              <p className="text-caption mb-4">{getArenaName(t.abbrv)}</p>
              <button
                type="button"
                className="button button--primary-yellow button--large d-block text-center"
                onClick={() => onAddToCalendar(t.abbrv)}
              >
                PRENUMERERA
              </button>
            </div>
          </div>
        ))}
        {showLoginModal && (
          <RequireLoginModal
            closeModal={() => setShowLoginModal(false)}
            login={login}
            heading="KALENDER"
            message="För att lägga till matcher i din kalender behöver du logga in på ditt
        Fotbollskonto."
          />
        )}
        {showCalendarModal && (
          <Modal
            closeModal={() => setShowCalendarModal(false)}
            heading="Starta prenumeration"
            content={
              <div className="text-center">
                <p className="text-regular mb-3">
                  Klicka på knappen nedan för att starta prenumerationen.
                  <br />
                  Om knappen inte fungerar kan du behöva kopiera länken manuellt
                  och lägga in i din kalender, se instruktioner längst ner på
                  sidan.
                </p>

                <a
                  type="button"
                  href={showCalendarModal}
                  className="button button--primary-yellow button--large mb-3"
                >
                  Prenumerera
                </a>

                <p>Länk: {showCalendarModal}</p>
              </div>
            }
          />
        )}
      </>
    );
  }

  return null;
}
